export const saveToLocalStorage = (storageKey, data) => {
  try {
    localStorage.setItem(storageKey, data);
  } catch (error) {
    console.error('Erro ao salvar os dados no localStorage:', error);
  }
};

export const loadFromLocalStorage = (storageKey) => {
  try {
    const data = localStorage.getItem(storageKey);
    if (data) {
      return data;
    }
    return null;
  } catch (error) {
    localStorage.removeItem("cartItems");
    console.error('Erro ao carregar os dados do localStorage:', error);
    return null;
  }
};

export const decryptToken = () => {
  try {
    var token = localStorage.getItem("token");
    if (token.startsWith('"') && token.endsWith('"')) {
      token = token.slice(1, -1);
    }
    return token;
  } catch (error) {
    localStorage.removeItem("token");
    console.error('Erro ao descriptografar o token:', error);decryptToken
    return null;
  }
};